module.exports = __webpack_public_path__ + "static/img/nanny3.85f54e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nanny3.png
// module id = mVGM
// module chunks = 14